import React from 'react';
import ReactDOM from 'react-dom/client';
import TagManager from 'react-gtm-module';
import ReactPixel from 'react-facebook-pixel';
import './index.css';
import App from './App';
import { store } from './store';
import { Provider } from 'react-redux';
import { FB_PIXEL_ID, REACT_GTM_ID } from './constants';
import { PinterestTag } from './helpers/pinterest';

const tagManagerArgs = {
  gtmId: REACT_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

const options = {
  autoConfig: true,
  debug: false,
};

ReactPixel.init(FB_PIXEL_ID, undefined, options);

PinterestTag.init();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
);
